import React from "react";
import Input from "../../../../Components/Common/Input/Input";
import ErrorMessage from "../../../../Components/Common/ErrorMessage/ErrorMessage";
import { ComparisonRow } from "../types/precon.types";
import { CHAR_LIMIT } from "../../../../utils/Common/Constant";
import Table, { Column } from "Components/Table/Table";
import Button from "Components/Common/Button/Button";

const numericOnly = (val: string) => val.replace(/[^0-9$,.]/g, "");

interface ComparisonTableProps {
  rows: ComparisonRow[];
  onRowChange: (
    index: number,
    field: keyof ComparisonRow,
    value: string,
  ) => void;
  onAddRow: () => void;
  onRemoveRow: (index: number) => void;
  error?: string;
  touched?: boolean;
  rowErrors?: (string | undefined)[];
}

const ComparisonTable = ({
  rows,
  onRowChange,
  onAddRow,
  onRemoveRow,
  error,
  touched,
  rowErrors,
}: ComparisonTableProps) => {
  return (
    <div>
      <div className="tableScroll">
        <Table
          tableClassName="compTable"
          data={rows}
          rowClassName={(row) => (row.isThis ? "thisRow" : "")}
          columns={
            [
              {
                header: "Project",
                render: (row, i) => (
                  <Input
                    className="left input-field"
                    value={row.project}
                    placeholder="Project name"
                    maxLength={CHAR_LIMIT.SHORT}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      onRowChange(i, "project", e.target.value)
                    }
                  />
                ),
              },
              {
                header: "Units",
                render: (row, i) => (
                  <Input
                    style={{ paddingLeft: "3px" }}
                    value={row.units}
                    maxLength={CHAR_LIMIT.SHORT}
                    placeholder="e.g. # of units or SF"
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      onRowChange(i, "units", numericOnly(e.target.value))
                    }
                  />
                ),
              },
              {
                header: "Budget",
                render: (row, i) => (
                  <div className="inputWithPrefix">
                    <span className="prefixSymbol">$</span>
                    <Input
                      value={row.budget}
                      maxLength={CHAR_LIMIT.SHORT}
                      placeholder="10000"
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        onRowChange(i, "budget", numericOnly(e.target.value))
                      }
                    />
                  </div>
                ),
              },
              {
                header: "Cost Less Sitework",
                render: (row, i) => (
                  <div className="inputWithPrefix">
                    <span className="prefixSymbol">$</span>
                    <Input
                      value={row.costLessSitework}
                      maxLength={CHAR_LIMIT.SHORT}
                      placeholder="8000"
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        onRowChange(
                          i,
                          "costLessSitework",
                          numericOnly(e.target.value),
                        )
                      }
                    />
                  </div>
                ),
              },
              {
                header: "Cost/Unit",
                render: (row, i) => (
                  <div className="inputWithPrefix">
                    <span className="prefixSymbol">$</span>
                    <Input
                      value={row.costPerUnit}
                      maxLength={CHAR_LIMIT.SHORT}
                      placeholder="200"
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        onRowChange(
                          i,
                          "costPerUnit",
                          numericOnly(e.target.value),
                        )
                      }
                    />
                  </div>
                ),
              },
              {
                header: "Total SF",
                render: (row, i) => (
                  <Input
                    style={{ paddingLeft: "3px" }}
                    value={row.totalSf}
                    maxLength={CHAR_LIMIT.SHORT}
                    placeholder="28,011"
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      onRowChange(i, "totalSf", numericOnly(e.target.value))
                    }
                  />
                ),
              },
              {
                header: "Cost/SF",
                render: (row, i) => (
                  <div className="inputWithPrefix">
                    <span className="prefixSymbol">$</span>
                    <Input
                      value={row.costPerSf}
                      maxLength={CHAR_LIMIT.SHORT}
                      placeholder="185"
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        onRowChange(i, "costPerSf", numericOnly(e.target.value))
                      }
                    />
                  </div>
                ),
              },
              {
                header: "",
                render: (_, i) => (
                  <Button
                    type="button"
                    className="tableRemoveBtn"
                    onClick={() => onRemoveRow(i)}
                    title="Remove row"
                  >
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <path
                        d="M1 1l10 10M11 1L1 11"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                      />
                    </svg>
                  </Button>
                ),
              },
            ] as Column<ComparisonRow>[]
          }
        />
        {rowErrors?.[0] && (
          <span
            className="field-error"
            style={{ fontSize: 11, display: "block", marginTop: 2 }}
          >
            {rowErrors[0]}
          </span>
        )}
      </div>
      <div id="comparisonRows">
        <ErrorMessage touched={touched} error={error} />
      </div>
      <div className="btnRow">
        <Button
          type="button"
          className="btn btnSecondary btnSm"
          onClick={onAddRow}
        >
          + Add Row
        </Button>
      </div>
    </div>
  );
};

export default ComparisonTable;
